import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  fetchOwnAnnouncementById,
  fetchOwnAnnouncements,
} from '@/api/announcements/announcementsApi';
import type { ClientAnnouncement } from '@/api/announcements/announcementsApi.types';
import type { PaginatedResult } from '@/api/pagination.types';
import { OWN_ANNOUNCEMENTS_QUERY_KEY } from '@/constants/queryKeys';

export const OWN_ANNOUNCEMENTS_PAGE_SIZE = 10;

export function useOwnAnnouncementsQuery(
  page: number,
  pageSize: number
): UseQueryResult<PaginatedResult<ClientAnnouncement>, Error> {
  return useQuery({
    queryKey: [...OWN_ANNOUNCEMENTS_QUERY_KEY, page, pageSize],
    queryFn: function load() {
      return fetchOwnAnnouncements(page, pageSize);
    },
    placeholderData: keepPreviousData,
  });
}

export function useOwnAnnouncementByIdQuery(
  announcementId: string | null
): UseQueryResult<ClientAnnouncement | null, Error> {
  return useQuery({
    queryKey: [...OWN_ANNOUNCEMENTS_QUERY_KEY, 'byId', announcementId],
    queryFn: function load() {
      if (announcementId === null) {
        return Promise.resolve(null);
      }
      return fetchOwnAnnouncementById(announcementId);
    },
    enabled: announcementId !== null,
    retry: false,
  });
}
